import { formatCompanyName } from "../../../common/formatters/CompanyNameFormatter";
import { TFunction } from "i18next";

export const walletOwner = (t: TFunction, walletInfo) =>
  walletInfo.ownerCompany
    ? formatCompanyName(t, walletInfo.ownerCompany)
    : t("nominee-dashboard:personal");
